/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShow,
      expression: "isShow"
    }],
    staticClass: "shy__loading-bar"
  }, [_c('div', {
    staticClass: "shy__loading-bar-inner",
    class: _vm.innerClasses,
    style: _vm.styles
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };